import React from "react";
import { useNavigate } from "react-router";

import { Button } from "../Base";

const PersonalVerificationAlert = () => {
  const navigate = useNavigate();

  // ========================================================================

  return (
    <div className="container">
      <div
        className="alert flex-wrap flex-md-nowrap mt-3 py-1 container justify-content-between alert-warning d-flex align-items-center"
      >
        <div className="w-100 mb-2 mb-md-0 mt-2 mt-sm-0">
          <i className="fa fa-info-circle text-warning me-2"></i>
          لطفا قبل از انجام هر کاری حساب خود را احراز کنید.
        </div>

        <Button
          btnClass="bg-white rounded-3 mb-0 mr-auto w-100 w-md-auto"
          text="احراز هویت"
          onClick={() => navigate("/profile")}
        />
      </div>
    </div>
  );
};

export default PersonalVerificationAlert;
